import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import QuoteComp from "../../Components/QuoteComp/QuoteComp";

const BuisnessModel: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Business Model" />
      <SubSection>
        <QuoteComp
          isQuote={true}
          text={
            "We intend to generate outstanding returns for our shareholders by selling innovative, exclusive ELF-Tech™ licenses, must have E-SPEC™ data and services, CADs, and consulting for positive disruption of the $3T/year engines industry."
          }
        />
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">Licensing for Engine or Parts Production</h4>
            <p className="inv-item-body">
              Core revenue will come from production licenses' ongoing royalties.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Exclusivity and Prototyping Licenses</h4>
            <p className="inv-item-body">
              Allowing manufacturers to test and adjust our parts and assemblies to their strengths,
              and for time or geography exclusivities if desired.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">E-SPEC™ Data and Software</h4>
            <p className="inv-item-body">
              E-SPEC users can explore how ELF-Tech innovations give their product the best edge in
              power, weight, efficiency, emissions and costs. This will become the "must use" global
              gold standard, and it will be the only product with all the ELF-Tech design data.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Engine or Parts CADs</h4>
            <p className="inv-item-body">
              From our growing library of parts Computer Aided Designs (CADs).
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Consulting Services</h4>
            <p className="inv-item-body">
              From our 30-years of R&D, test engines, and assembly knowledge.
            </p>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default BuisnessModel;
